import { Injectable } from '@angular/core';
import { HttpUtility } from '@utility/httpUtility';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { UserCreateModel, UserModel } from '../models/user-model';
import { CheckModel } from '@shared/authentication/model/check-model';
import { Bearertoken } from '@shared/authentication/model/bearer-token-model';

@Injectable({ providedIn: 'root' })
export class UsersService {
    constructor(private httpUtility: HttpUtility) {}

    getUsersById(id: string): Observable<UserModel> {
        return this.httpUtility.get<UserModel>(`${environment.apiUrl}/users/${id}/with-agency`);
    }

    editUsers(users: UserModel) {
        return this.httpUtility.put(`${environment.apiUrl}/users`, users);
    }

    addUsers(user: UserCreateModel) {
        return this.httpUtility.post(`${environment.apiUrl}/users`, user);
    }

    // Route: DELETE /api/v1/users/{id:guid} → Features/Users/UserController.Delete
    deleteUsersById(id: string): Observable<void> {
        return this.httpUtility.delete<void>(`${environment.apiUrl}/users/${id}`);
    }

    // Route: DELETE /api/v1/users/{id:guid}/hard → Features/Users/UserController.HardDelete
    hardDeleteUser(id: string): Observable<void> {
        return this.httpUtility.delete<void>(`${environment.apiUrl}/users/${id}/hard`);
    }

    getAllUsers(): Observable<UserModel[]> {
        return this.httpUtility.get<UserModel[]>(
            `${environment.apiUrl}/users/with-agency?roleDescriptors=ExternalAgent&roleDescriptors=LeadManager&roleDescriptors=SalesManager&roleDescriptors=PreCallManager&roleDescriptors=Owner&roleDescriptors=Admin&roleDescriptors=InternalAgent&roleDescriptors=AgencyManager`,
        );
    }


    getUsersAgents(): Observable<UserModel[]> {
        return this.httpUtility.get<UserModel[]>(`${environment.apiUrl}/users/agents`);
    }

    getUserByEmail(email: string): Observable<CheckModel> {
        return this.httpUtility.get<CheckModel>(`${environment.apiUrl}/users/verify-email?email=${email}`);
    }

    getUserByUserName(userName: string): Observable<CheckModel> {
        return this.httpUtility.get<CheckModel>(`${environment.apiUrl}/users/verify-username?userName=${userName}`);
    }

    userImpersonate(userId: string): Observable<Bearertoken> {
        return this.httpUtility.post(`${environment.apiUrl}/impersonate?id=${userId}`, {});
    }

    resendRegistrationEmail(userId: string): Observable<any> {
        return this.httpUtility.get(`${environment.apiUrl}/users/${userId}/resendRegistrationEmail`);
    }

    getAgentLeadStats(agentId: string): Observable<any> {
        return this.httpUtility.get<any>(`${environment.apiUrl}/leads/agent-dashboard/${agentId}`);
    }

    // WI-98: per-agent never-called open-lead counts, scoped server-side
    // (Agency Managers get their agency's agents; Owner/Admin get all).
    getNeverCalledByAgent(): Observable<{ agentUserId: string; agentName: string; agencyName: string; neverCalledCount: number }[]> {
        return this.httpUtility.get<{ agentUserId: string; agentName: string; agencyName: string; neverCalledCount: number }[]>(
            `${environment.apiUrl}/leads/never-called-by-agent`,
        );
    }

    bulkUpdateStatus(userIds: string[], activate: boolean): Observable<{ processed: number; total: number }> {
        return this.httpUtility.put<{ processed: number; total: number }>(
            `${environment.apiUrl}/users/bulk-status`,
            { userIds, activate }
        );
    }
}
